import React from 'react';
import moment from 'moment';

interface CustomCalendarHeaderProps {
	date: Date;
	localizer: any;
	label?: string;
	format?: string;
}

const CustomCalendarHeader: React.FC<CustomCalendarHeaderProps> = ({
	date,
	localizer,
	label,
	format,
}) => {
	// Format as "09 Tue" (day number with leading zero + abbreviated weekday)
	// Always use this format to ensure consistency across all views, especially day view
	const formattedLabel = moment(date).format('DD ddd');

	return <div className="rbc-header footnoteregular font-normal">{formattedLabel}</div>;
};

export default CustomCalendarHeader;
